// removed by extract-text-webpack-plugin
module.exports = {"loading__container":"G8a24d7","loading__item":"Gaa0373","loading__image":"G8429bf"};